import { Evaluator } from "@/types/app/evaluator";

import { NestedTarget } from "@/lib/filtering/filters";
import { EntityIcon } from "@components/library/Entities/EntityIcon";
import { FileLabelWithPopover } from "@components/library/Entities/FileLabelWithPopover";
import { EntityLabel } from "@components/library/Entities/EntityLabel";

export const JudgmentFilterTargetRenderer = (filterTarget: NestedTarget, skipIcon: boolean = false) => {
  return (
    <div className="flex items-center gap-6 fill-icon-base-3">
      {!skipIcon && <EntityIcon type="evaluator" size={14} />}
      <span className="text-12-12 font-medium text-text-base-1">{filterTarget.label}</span>
    </div>
  );
};

export const EvaluatorFilterTargetRenderer = (evaluators: Evaluator[], evaluator: Evaluator) => {
  const hasDuplicateName = evaluators.some((e) => e.version_id !== evaluator.version_id && e.name === evaluator.name);
  return (
    <div className="flex items-center gap-6 fill-icon-base-3">
      <FileLabelWithPopover
        file={evaluator}
        interactive={false}
        displayFile
        side="right"
        hideVersionId={!hasDuplicateName}
        size={20}
        openDelay={400}
      />
    </div>
  );
};

export const EvaluatorFilterWithoutPopUpTargetRenderer = (target: string) => {
  return (
    <div className="flex items-center fill-icon-base-3">
      <EntityLabel entity={"evaluator"} size={20} fileName={target} environment="" />
    </div>
  );
};
